module.exports = function truncateString(str, length) {
  if (str.length > length) {
    return str.substr(0, length / 2) + '...' + str.substr(str.length - length / 4, str.length);
  }
  return str;

  // more precise version if needed
  // http://stackoverflow.com/a/831583
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@uppy/dashboard/lib/utils/truncateString.js
// module id = 1515
// module chunks = 0